var MarginCalculatorPresenter = /** @class */ (function () {
    function MarginCalculatorPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
        this.strategyList = [];
        this.PayloadList = [];
    }
    MarginCalculatorPresenter.prototype.calculateMargin = function (req) {
        var _this = this;
        this.actions.calculateMargin.startLoader();
        this.actions.calculateMargin.hideError();
        this.actions.calculateMargin.setError({ isOpen: false, error: undefined });
        this.usecase.calculateMargin.execute({
            onSuccess: function (data) {
                _this.actions.calculateMargin.getCalculatedMargin(data);
            },
            onError: function (error) {
                _this.actions.calculateMargin.setError({ isOpen: true, error: error });
                _this.actions.calculateMargin.stopLoader();
            },
        }, req);
    };
    MarginCalculatorPresenter.prototype.flushcalculateMarginData = function () {
        this.actions.calculateMargin.flushMarginData();
    };
    MarginCalculatorPresenter.prototype.getSearchSymbol = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getSearchedSymbolData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MarginCalculatorPresenter.prototype.getDerivativeDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getDerivativeDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MarginCalculatorPresenter.prototype.getStrikePriceList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getStrikePriceList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MarginCalculatorPresenter.prototype.getExpiryDate = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getExpirydate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    MarginCalculatorPresenter.prototype.getStrategyList = function () {
        return this.strategyList;
    };
    MarginCalculatorPresenter.prototype.editStrategy = function (data) {
        this.strategyList = data;
    };
    MarginCalculatorPresenter.prototype.addStrategy = function (data) {
        this.strategyList.push(data);
    };
    MarginCalculatorPresenter.prototype.deleteStrategy = function (index) {
        this.strategyList.splice(index, 1);
    };
    MarginCalculatorPresenter.prototype.clearAllStrategy = function () {
        this.strategyList = [];
    };
    MarginCalculatorPresenter.prototype.getPayloadList = function () {
        return this.PayloadList;
    };
    MarginCalculatorPresenter.prototype.editPayload = function (data) {
        this.PayloadList = data;
    };
    MarginCalculatorPresenter.prototype.addPayload = function (data) {
        this.PayloadList.push(data);
    };
    MarginCalculatorPresenter.prototype.deletePayload = function (index) {
        this.PayloadList.splice(index, 1);
    };
    MarginCalculatorPresenter.prototype.clearAllPayload = function () {
        this.PayloadList = [];
    };
    return MarginCalculatorPresenter;
}());
export default MarginCalculatorPresenter;
